const Error = ()=>{
    return (
        <div>
            <h1>Oops ! kindly Refresh it .</h1>
        </div>
    )
}
export default Error;